import React from 'react';
import server from '../../server';
import ReactExport from "react-data-export";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

class PatientResumes extends React.Component{
    render(){
        let monthsLabel = ["","Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"]

        let thisMonth = new Date();
  
        thisMonth = thisMonth.getMonth() + 1;
  
        return(
            <div class="col1-list h-100p">
                <div style={{paddingLeft: 40, borderBottom:"0px solid grey"}} class="peers w-100p ai-c jc-sb content-header">
                    <div class="content-header__left">
                        <div class="content-header__title">
                        </div>
                    </div>
                    <div class="btn-group gap-10 jc-c" role="group">
                        <button class="open-details btn btn-clear peers ai-c pX-5 pY-0 mB-5 bdrs-2 mR-5 cur-p c-client-default" type="button">
                            <i class="fa fa-filter fsz-xl"></i>
                            Filtrar
                        </button>
                    </div>
                </div>
                <div class="scrollable h-100p">
                    <div class="content-data">
                        <div class="col-md-12 pY-20">
                            <div class="col-sm-4 mB-10">
                                <div class="bdrs-2 w-100p peers bd cur-p open-details">
                                    <div>
                                        <i class="fa fa-stethoscope fsz-xl c-client-secondary pX-20 pT-20 pB-0"></i>
                                    </div>
                                    <div class="client-info pX-20 pT-0 pB-20">
                                        <h5 class="c-client-default">
                                            <b>Atendimentos Realizados</b>
                                        </h5>
                                        <hr class="small m-0"/>
                                        <div class="peers ai-c jc-sb">
                                            <div>
                                                <span class="c-client-secondary fsz-xs">{monthsLabel[thisMonth]} de 2018</span>
                                                <h3 class="m-0">{this.props.totalAtt}</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-sm-4 mB-10">
                                <div class="bdrs-2 w-100p peers bd cur-p open-details">
                                    <div>
                                        <i class="fa fa-stethoscope fsz-xl c-client-secondary pX-20 pT-20 pB-0"></i>
                                    </div>
                                    <div class="client-info pX-20 pT-0 pB-20">
                                        <h5 class="c-client-default">
                                            <b>Atendimentos A Realizar</b>
                                        </h5>
                                        <hr class="small m-0"/>
                                        <div class="peers ai-c jc-sb">
                                            <div>
                                                <span class="c-client-secondary fsz-xs">{monthsLabel[thisMonth]} de 2018</span>
                                                <h3 class="m-0">{this.props.totalApp - this.props.totalAtt}</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

class Finances extends React.Component{
    state = {
        recieve:0,
        toRecieve:0
    }

    render(){
        let monthsLabel = ["","Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"]

        let thisMonth = new Date();
        let thisYear = thisMonth.getFullYear();
  
        thisMonth = thisMonth.getMonth() + 1;
  
        return(
            <div class="col1-list h-100p">
                <div style={{paddingLeft: 40, borderBottom:"0px solid grey"}} class="peers w-100p ai-c jc-sb content-header">
                    <div class="content-header__left">
                        <div class="content-header__title">
                        </div>
                    </div>
                    <div class="btn-group gap-10 jc-c" role="group">
                        <button class="open-details btn btn-clear peers ai-c pX-5 pY-0 mB-5 bdrs-2 mR-5 cur-p c-client-default" type="button">
                            <i class="fa fa-filter fsz-xl"></i>
                            Filtrar
                        </button>
                    </div>
                </div>
                <div class="scrollable h-100p">
                    <div class="content-data">
                        <div class="col-md-12 pY-20">
                        {server.userType != "doctor" ?
                        <div>
                            <div class="col-sm-4 mB-10">
                                <div class="bdrs-2 w-100p peers bd  cur-p open-details">
                                    <div>
                                        <i class="fa fa-money fsz-xl c-client-secondary pX-20 pT-20 pB-0"></i>
                                    </div>
                                    <div class="client-info pX-20 pT-0 pB-20">
                                        <h5 class="c-client-default">
                                            <b>{server.userType == "doctor" ? "Honorários recebidos" : "Total arrecadado"}</b>
                                        </h5>
                                        <hr class="small m-0"/>
                                        <div class="peers ai-c jc-sb">
                                            <div>
                                                <span class="c-client-secondary fsz-xs">{monthsLabel[thisMonth]} de {thisYear}</span>
                                                <h3 class="m-0">R$ {this.props.totalGained + (this.props.totalGained.toString().indexOf(".") != -1 ? "0" : "")}</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-sm-4 mB-10">
                                <div class="bdrs-2 w-100p peers bd  cur-p open-details">
                                    <div>
                                        <i class="fa fa-download fsz-xl c-client-secondary pX-20 pT-20 pB-0"></i>
                                    </div>
                                    <div class="client-info pX-20 pT-0 pB-20">
                                        <h5 class="c-client-default">
                                            <b>{server.userType == "doctor" ? "Honorários à receber" : "Total à receber"}</b>
                                        </h5>
                                        <hr class="small m-0"/>
                                        <div class="peers ai-c jc-sb">
                                            <div>
                                                <span class="c-client-secondary fsz-xs">{monthsLabel[thisMonth]} de {thisYear}</span>
                                                <h3 class="m-0">R$ {parseFloat(this.props.totalToGain).toFixed(2).toString()}</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div> : <div></div>}

                            <div class="col-sm-4 mB-10">
                                <div class="bdrs-2 w-100p peers bd cur-p open-details">
                                    <div>
                                        <i class="fa fa-stethoscope fsz-xl c-client-secondary pX-20 pT-20 pB-0"></i>
                                    </div>
                                    <div class="client-info pX-20 pT-0 pB-20">
                                        <h5 class="c-client-default">
                                            <b>{["doctor", "secretary"].indexOf(server.userType) != -1 ? "Pacientes Indicados" : "Atendimentos Marcados"}</b>
                                        </h5>
                                        <hr class="small m-0"/>
                                        <div class="peers ai-c jc-sb">
                                            <div>
                                                <span class="c-client-secondary fsz-xs">{monthsLabel[thisMonth]} de {thisYear}</span>
                                                <h3 class="m-0">{this.props.totalApp}</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

class AppointmentDetail extends React.Component{
    state = {
        style:"",
        status:"",
        doctorName: "",
        patient:{}
    }
    
    componentWillMount(){
        this.loadPatient();
        this.checkFisioterapist();
        this.checkStatus();
    }

    addDataset = () =>{
        this.props.addDataset({
            name:this.state.patient.name,
            email:this.state.patient.email,
            cpf:this.state.patient.cpf,
            secretary:this.state.secretaryName,
            doctor:this.state.doctorName,
            fisioterapist: this.state.fisioterapistName,
            date:this.props.appointment.date,
            paid:this.props.appointment.charged == true ? "Sim" : "Não",
            status:this.state.status,
            release:this.props.appointment.release == true ? "Sim" : "Não"
        })
    }

    loadPatient = () =>{
        server.get("users/" + this.props.appointment.patientId, (data) =>{
            this.setState({patient: data});
        })
    }

    checkFisioterapist = () =>{
        const id = this.props.appointment.fisioterapistId;
        if(id == null) this.setState({fisioterapistName:"Nenhum"},this.checkDoctor);
        else{
            server.get("users/" + id, data =>{
                this.setState({fisioterapistName: data.name},this.checkDoctor)
            });
        }
    }

    checkDoctor = () =>{
        const id = this.props.appointment.doctorId;
        if(id == null) this.setState({doctorName:"Nenhum"},this.checkSecretary);
        else{
            server.get("users/" + id, data =>{
                this.setState({doctorName: data.name},this.checkSecretary)
            });
        }
    }

    checkSecretary = () =>{
        const id = this.props.appointment.secretaryId;
        if(id == null) this.setState({secretaryName:"Nenhum"},this.addDataset);
        else{
            server.get("users/" + id, data =>{
                this.setState({secretaryName: data.name},() => this.addDataset())
            });
        }
    }
    
    charge = () =>{
        server.charge_appointment(this.props.appointment.id,() =>{
            this.props.alert("Consulta Cobrada Com Sucesso!", "Registramos o pagamento dessa consulta!", "success");
            this.props.refresh();
        }, () => this.props.alert("Erro ao cobrar consulta", "Tente novamente mais tarde!", "error"));
    }

    checkStatus = () =>{
        // Check appointment status
        const today = new Date();
        const appointmentDate = new Date(this.props.appointment.date);
        console.log(this.props.appointment)
        if(server.userType == "patient"){
            if(this.props.appointment.fisioterapistOpinion != 0) this.setState({status:"Alta", style:"bgc-green-50 c-green-700"});
            else this.setState({status:"Tratando",style:"bgc-blue-50 c-blue-700"})
        }else{
            if(this.props.appointment.status == 0) this.setState({status:"Agendado",style:"bgc-blue-50 c-blue-700"});
            else if(this.props.appointment.status == 1) this.setState({status:"Atendido", style:"bgc-green-50 c-green-700"});
            else this.setState({status:"Cancelado",style:"bgc-red-50 c-red-700"})           
        }
    }

    render(){
        const userType = server.userType;
        if(userType == "fisioterapist")
            return(
                <div class="table-body peers jc-sb pY-20 bdB">
                    <div class="w-100p pR-10">
                        <h5 class="m-0">
                            <b>{this.state.patient.name}</b>
                        </h5>
                        <h5 class="fsz-sm m-0 p-0"><b>{this.state.patient.email}</b>
                        </h5>
                        <h5 class="fsz-sm c-client-secondary m-0 p-0">{this.state.patient.cpf}</h5>
                        <div class="d-n@md+ w-100p mT-5">
                            <h5 class="fsz-xs c-client-default m-0">Quem indicou</h5>
                            <h5 class="m-0">{this.state.secretaryName}</h5>
                        </div>
                    </div>
                    <div class="d-n@md- w-100p">
                        <h5 class="m-0">{this.state.secretaryName}</h5>
                    </div>
                    <div class="w-100p">
                        <h5 class="m-0">{this.state.doctorName}</h5>
                        <div class="d-n@md+ w-100p mT-5">
                            <h5 class="m-0 fsz-xs c-client-default">{this.props.appointment.date}</h5>
                            <h5 class="fsz-sm c-client-secondary m-0 p-0">({this.props.appointment.clinic == true ? "Clínica" : "Domiciliar"})</h5>
                        </div>
                        <div class="peers mT-5 d-n@sm+">
                            {this.props.appointment.charged ? <span class="badge badge-pill fsz-xs bgc-green-500 c-white mR-5 badge-vs">Pago</span> : <div></div>}
                            {this.props.appointment.release ? <span class="badge badge-pill badge-equal bgc-green-50 c-green-700 badge-vs">Alta</span> : <div></div>}
                            <span class={"badge badge-pill badge-equal badge-vs " + this.state.style}>{this.state.status}</span>
                        </div>

                    </div>
                    <div class="d-n@md- w-100p">
                        <h5 class="m-0">{this.props.appointment.batchId}</h5>
                    </div>
                    <div class="d-n@md- w-100p">
                        <h5 class="m-0">{server.fullDateString(this.props.appointment.date)}</h5>
                        <h5 class="fsz-sm c-client-secondary m-0 p-0">({this.props.appointment.onClinic == true ? "Clínica" : "Domiciliar"})</h5>
                    </div>
                    <div class="d-n@md- w-100p">
                        <h5 class="m-0">R${parseFloat(this.props.appointment.price).toFixed(2).toString()}</h5>
                    </div>
                    {/*<div class="w-50p peers jc-c d-n@sm-">
                        <button 
                            onClick={this.props.appointment.charged ? null : this.charge}
                            disabled={this.props.appointment.charged} 
                            className={"btn " + (this.props.appointment.charged ? "btn-muted" : "btn-default")}>
                            {this.props.appointment.charged ? "Pago" : "Pagar"}
                        </button>
                    </div>*/}
                    <div class="w-50p peers jc-c d-n@sm-">
                            {this.props.appointment.charged ? <span class="badge badge-pill fsz-xs bgc-green-500 c-white mR-5 badge-vs">Pago</span> : <div></div>}
                            {this.props.appointment.release ? <span class="badge badge-pill badge-equal bgc-green-50 c-green-700 badge-vs">Alta</span> : <div></div>}
                        <span class={"badge badge-pill badge-equal badge-vs " + this.state.style}>{this.state.status}</span>
                    </div>
                </div>
            )
        else if(userType == "secretary"){ 
            return(
                <div class="table-body peers jc-sb pY-20 bdB">
                    <div class="w-100p pR-10">
                        <h5 class="m-0">
                            <b>{this.state.patient.name}</b>
                        </h5>
                        <h5 class="fsz-sm m-0 p-0"><b>{this.state.patient.email}</b>
                        </h5>
                        <h5 class="fsz-sm c-client-secondary m-0 p-0">{this.state.patient.cpf}</h5>
                        <div class="d-n@md+ w-100p mT-5">
                            <h5 class="fsz-xs c-client-default m-0">Fisioterapeuta</h5>
                            <h5 class="m-0">{this.state.fisioterapistName}</h5>
                        </div>
                    </div>
                    <div class="d-n@md- w-100p">
                        <h5 class="m-0">{this.state.fisioterapistName}</h5>
                    </div>
                    <div class="w-100p">
                        <h5 class="m-0">{this.state.doctorName}</h5>
                        <div class="d-n@md+ w-100p mT-5">
                            <h5 class="m-0 fsz-xs c-client-default">{this.props.appointment.date}</h5>
                            <h5 class="fsz-sm c-client-secondary m-0 p-0">({this.props.appointment.clinic == true ? "Clínica" : "Domiciliar"})</h5>
                        </div>
                        <div class="peers mT-5 d-n@sm+">
                            {this.props.appointment.charged ? <span class="badge badge-pill fsz-xs bgc-green-500 c-white mR-5 badge-vs">Pago</span> : <div></div>}
                            {this.props.appointment.release ? <span class="badge badge-pill badge-equal bgc-green-50 c-green-700 badge-vs">Alta</span> : <div></div>}
                            <span class={"badge badge-pill badge-equal badge-vs " + this.state.style}>{this.state.status}</span>
                        </div>

                    </div>
                    <div class="d-n@md- w-100p">
                        <h5 class="m-0">{server.fullDateString(this.props.appointment.date)}</h5>
                        <h5 class="fsz-sm c-client-secondary m-0 p-0">({this.props.appointment.clinic == true ? "Clínica" : "Domiciliar"})</h5>
                    </div>
                    <div class="w-50p peers jc-c d-n@sm-">
                            {this.props.appointment.charged ? <span class="badge badge-pill fsz-xs bgc-green-500 c-white mR-5 badge-vs">Pago</span> : <div></div>}
                            {this.props.appointment.release ? <span class="badge badge-pill badge-equal bgc-green-50 c-green-700 badge-vs">Alta</span> : <div></div>}
                        <span class={"badge badge-pill badge-equal badge-vs " + this.state.style}>{this.state.status}</span>
                    </div>
                </div>
            )
        }else if(userType == "patient"){
            return(
                <div class="table-body peers jc-sb pY-20 bdB">
                    <div class="d-n@md- w-100p">
                        <h5 class="m-0">{this.state.fisioterapistName}</h5>
                    </div>
                    <div class="w-100p">
                        <h5 class="m-0">{this.state.doctorName}</h5>
                        <div class="d-n@md+ w-100p mT-5">
                            <h5 class="m-0 fsz-xs c-client-default">{this.props.appointment.date}</h5>
                            <h5 class="fsz-sm c-client-secondary m-0 p-0">({this.props.appointment.onClinic == true ? "Clínica" : "Domiciliar"})</h5>
                        </div>
                        <div class="peers mT-5 d-n@sm+">
                            {this.props.appointment.charged ? <span class="badge badge-pill fsz-xs bgc-green-500 c-white mR-5 badge-vs">Pago</span> : <div></div>}
                            {this.props.appointment.release ? <span class="badge badge-pill badge-equal bgc-green-50 c-green-700 badge-vs">Alta</span> : <div></div>}
                            <span class={"badge badge-pill badge-equal badge-vs " + this.state.style}>{this.state.status}</span>
                        </div>

                    </div>
                    <div class="d-n@md- w-100p">
                        <h5 class="m-0">{server.fullDateString(this.props.appointment.date)}</h5>
                        <h5 class="fsz-sm c-client-secondary m-0 p-0">({this.props.appointment.onClinic == true ? "Clínica" : "Domiciliar"})</h5>
                    </div>
                    <div class="w-50p peers jc-c d-n@sm-">
                            {this.props.appointment.charged ? <span class="badge badge-pill fsz-xs bgc-green-500 c-white mR-5 badge-vs">Pago</span> : <div></div>}
                            {this.props.appointment.release ? <span class="badge badge-pill badge-equal bgc-green-50 c-green-700 badge-vs">Alta</span> : <div></div>}
                        <span class={"badge badge-pill badge-equal badge-vs " + this.state.style}>{this.state.status}</span>
                    </div>
                </div>
            )
        }else{
            return(
                <div class="table-body peers jc-sb pY-20 bdB">
                    <div class="w-100p pR-10">
                        <h5 class="m-0">
                            <b>{this.state.patient.name}</b>
                        </h5>
                        <h5 class="fsz-sm m-0 p-0"><b>{this.state.patient.email}</b>
                        </h5>
                        <h5 class="fsz-sm c-client-secondary m-0 p-0">{this.state.patient.cpf}</h5>
                        <div class="d-n@md+ w-100p mT-5">
                            <h5 class="fsz-xs c-client-default m-0">Fisioterapeuta</h5>
                            <h5 class="m-0">{this.state.fisioterapistName}</h5>
                        </div>
                    </div>
                    <div class="d-n@md- w-100p">
                        <h5 class="m-0">{this.state.fisioterapistName}</h5>
                    </div>
                    <div class="w-100p">
                        <h5 class="m-0">{this.state.secretaryName}</h5>
                        <div class="d-n@md+ w-100p mT-5">
                            <h5 class="m-0 fsz-xs c-client-default">{server.fullDateString(this.props.appointment.date)}</h5>
                            <h5 class="fsz-sm c-client-secondary m-0 p-0">({this.props.appointment.clinic == true ? "Clínica" : "Domiciliar"})</h5>
                        </div>
                        <div class="peers mT-5 d-n@sm+">
                            {this.props.appointment.charged ? <span class="badge badge-pill fsz-xs bgc-green-500 c-white mR-5 badge-vs">Pago</span> : <div></div>}
                            {this.props.appointment.release ? <span class="badge badge-pill badge-equal bgc-green-50 c-green-700 badge-vs">Alta</span> : <div></div>}
                            <span class={"badge badge-pill badge-equal badge-vs " + this.state.style}>{this.state.status}</span>
                        </div>

                    </div>
                    <div class="d-n@md- w-100p">
                        <h5 class="m-0">{this.props.appointment.date}</h5>
                        <h5 class="fsz-sm c-client-secondary m-0 p-0">({this.props.appointment.clinic == true ? "Clínica" : "Domiciliar"})</h5>
                    </div>
                    <div class="w-50p peers jc-c d-n@sm-">
                            {this.props.appointment.charged ? <span class="badge badge-pill fsz-xs bgc-green-500 c-white mR-5 badge-vs">Pago</span> : <div></div>}
                            {this.props.appointment.release ? <span class="badge badge-pill badge-equal bgc-green-50 c-green-700 badge-vs">Alta</span> : <div></div>}
                        <span class={"badge badge-pill badge-equal badge-vs " + this.state.style}>{this.state.status}</span>
                    </div>
                </div>
            )
        }

    }
}

class Filter extends React.Component{
    render(){
        return(
            <div class="col1-app__side-details jc-fs bdL bgc-white mobile-scroll">
                <div class="inner-content ">
                        <div>
                            <h3 class="ta-c mB-0">Filtro</h3>
                            <span class="fsz-xs c-client-secondary"></span>
                            <hr class="small bdc-client-default mY-10"/>
                        </div>
                        <button>
                            <i class="material-icons">close</i>
                        </button>
                    </div>
                    <div class="p-10 mobile-scroll scrollable">

                        <div class="p-10 peers ai-c jc-sb  w-100p">
                            <div class="p-10  w-100p bdB">
                                <div class="p-0 w-100p">
                                    <label>Período</label>
                                </div>
                                <div class="form-group pR-10 pL-0 mB-10 col-sm-6 date-time-input">
                                    <label>Início</label>
                                    <input class="form-control" name="inputDate" type="date"/>
                                </div>
                                <div class="form-group  m-0 pR-10 pL-0 col-sm-6 date-time-input">
                                    <label>Fim</label>
                                    <input class="form-control" name="inputDate" type="date"/>
                                </div>
                            </div>
                        </div>

                        <div class="form-group pX-10 mB-10 col-sm-12 w-100p">
                            <div class="p-0 w-100p">
                                <label>Período</label>
                            </div>
                            <div class="form-group mB-10 col-sm-6 w-100p">
                                <div class="radio radio-client-default">
                                    <input type="radio" name="periodo" id="radio-1" value="Mensal"/>
                                    <label for="radio-1">Mensal</label>
                                </div>
                                <div class="radio radio-client-default">
                                    <input type="radio" name="periodo" id="radio-2" value="Trimestral"/>
                                    <label for="radio-2">Trimestral</label>
                                </div>
                                <div class="radio radio-client-default">
                                    <input type="radio" name="periodo" id="radio-3" value="Semestral"/>
                                    <label for="radio-3">Semestral</label>
                                </div>
                                <div class="radio radio-client-default">
                                    <input type="radio" name="periodo" id="radio-3" value="Anual"/>
                                    <label for="radio-3">Anual</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="bdT p-20 peers jc-c ai-c bgc-client-default">
                        <button class="open-details fsz-xs btn  full btn-clear peers ai-c pX-5 pY-0 bdrs-2 mR-3 cur-p c-client-default-inverse" type="button">
                            Aplicar filtro
                        </button>
                    </div>
                </div>
        )
    }
}

class Management extends React.Component{
    state = {
        filter:"",
        filterPage:0,
        datasets: [],
        appointmentDetails: [],
        totalApp:0,
        totalGained:0,
        totalToGain:0,
        totalAtt:0,
        key:0
    }

    componentWillMount(){
        this.loadAppointments();
    }

    loadAppointments = () =>{
        let appointments = []
        let today = new Date();
        let todayDate = today.getDate() + "/" + (today.getMonth() + 1) + "/" + today.getFullYear();

        let totalVinc = 0;
        let totalApp = 0;
        let totalAtt = 0;

        let that = this;

        server.get("extracts/" + server.userType + "/" + server.user.id, (data) => {
            let appHtml = [];

            data.appointments = data.appointments.reverse()

            for(let app in data.appointments){
                let appointmentData = data.appointments[app];
                appHtml.push(<AppointmentDetail 
                    addDataset={this.addDataset} 
                    key={appointmentData.id} 
                    appointment={appointmentData}
                    refresh={this.loadAppointments}
                    alert={this.props.alert}/>)
            }

            that.setState({today:todayDate, 
                           fisioName:server.user.name,
                           totalVinc:totalVinc,
                           totalGained: data.totalGained,
                           totalToGain: data.totalToGain,
                           appointmentDetails:appHtml,
                           totalApp:data.totalAppointments,
                           totalAtt:0});

        })
    }

    addDataset = (dataset) =>{
        let datasets = this.state.datasets;
        datasets.push(dataset);
        this.setState({datasets:datasets});
    }

    filter = () =>{

        const filter = this.state.filter.toLowerCase();
        let filtered = {};
        let page = 0;
        let i = 0;

        this.state.appointmentDetails.forEach(appointment =>{
            /*const split = appointment.key.split("/?/");
            const name = split[0].toLowerCase();
            const cpf = split[1].toLowerCase();*/

            if(true){
                i += 1;
                if(i % 10 == 0) page += 1;
                if(filtered[page] == null) filtered[page] = [];

                filtered[page].push(appointment)
            };
        })

        return filtered;
    }

    render(){
        const filtered = this.filter();

        const headers = {
            "fisioterapist":
            <div class="table-header peers ai-c jc-sb pY-20 bdB">
                <div class="w-100p">
                    <h5> Paciente </h5>
                </div>
                <div class="d-n@md- w-100p">
                    <h5> Quem indicou </h5>
                </div>
                <div class="w-100p">
                    <h5> Médico </h5>
                </div>
                <div class="d-n@md- w-100p">
                    <h5> Tratamento </h5>
                </div>
                <div class="d-n@md- w-100p">
                    <h5> Data </h5>
                </div>
                <div class="d-n@md- w-100p">
                    <h5> Remuneração </h5>
                </div>
                <div class="w-50p ta-c d-n@sm-">
                    Status
                </div>
            </div>,

            "secretary":
            <div class="table-header peers ai-c jc-sb pY-20 bdB">
                <div class="w-100p">
                    <h5> Paciente </h5>
                </div>
                <div class="d-n@md- w-100p">
                    <h5> Fisioterapeuta </h5>
                </div>
                <div class="w-100p">
                    <h5> Médico </h5>
                </div>
                <div class="d-n@md- w-100p">
                    <h5> Consulta </h5>
                </div>
                <div class="w-50p ta-c d-n@sm-">
                    Status
                </div>
            </div>,
            "doctor":
            <div class="table-header peers ai-c jc-sb pY-20 bdB">
                <div class="w-100p">
                    <h5> Paciente </h5>
                </div>
                <div class="d-n@md- w-100p">
                    <h5> Fisioterapeuta </h5>
                </div>
                <div class="w-100p">
                    <h5> Quem Indicou </h5>
                </div>
                <div class="d-n@md- w-100p">
                    <h5> Consulta </h5>
                </div>
                <div class="w-50p ta-c d-n@sm-">
                    Status
                </div>
            </div>,
            "patient":
            <div class="table-header peers ai-c jc-sb pY-20 bdB">
                <div class="w-100p">
                    <h5> Fisioterapeuta </h5>
                </div>
                <div class="d-n@md- w-100p">
                    <h5> Médico </h5>
                </div>
                <div class="w-100p">
                    <h5> Consulta </h5>
                </div>
                <div class="w-50p ta-c d-n@sm-">
                    Status
                </div>
            </div>,
        }

        return(
            <div class="col1-app">
                <div class="col1-app__wrapper">
                    <div class="col1-list h-100p">
                        <div class="peers w-100p ai-c jc-sb content-header">
                            <div class="content-header__left peer jc-sb w-100p">
                                <div class="peers ai-c">
                                    <div class="content-header__title">
                                        <h3 class="m-0">
                                            {server.userType == "patient" || server.userType == "fisioterapist" ? "Suas Consultas" : "Suas Indicações"}
                                        </h3>
                                    </div>
                                </div>

                                <div class="btn-group  peers ai-c" role="group">
                                <ExcelFile filename={"Acompanhamento_Iblue_" + this.state.fisioName + "_" + this.state.today} 
                                           element={<button class="btn btn-clear pX-5 pY-0 bdrs-2 mR-5 cur-p  c-client-default peers ai-c" type="button"><i class="fa fa-file-excel-o fsz-xl"></i>Exportar excel</button>}>
                                    <ExcelSheet data={this.state.datasets} name="Acompanhamento IBlue">
                                        <ExcelColumn label="Nome Paciente" value="name"/>
                                        <ExcelColumn label="Email Paciente" value="email"/>
                                        <ExcelColumn label="CPF Paciente" value="cpf"/>
                                        <ExcelColumn label="Quem Indicou" value="secretary"/>
                                        <ExcelColumn label="Médico" value="doctor"/>
                                        <ExcelColumn label="Fisioterapeuta" value="fisioterapist"/>
                                        <ExcelColumn label="Data" value="date"/>
                                        <ExcelColumn label="Pago" value="paid"/>
                                        <ExcelColumn label="Status" value="status"/>
                                        <ExcelColumn label="Alta" value="release"/>
                                    </ExcelSheet>
                                </ExcelFile>
                                </div>
                            </div>
                        </div>
                        <div class="scrollable h-100p">
                            <div class="inner-scrollable-data">
                                <div class="content-data peers  ai-c">
                                    {server.userType == "patients" ? 
                                        <PatientResumes totalApp={this.state.totalApp} totalAtt={this.state.totalAtt}/> : 
                                        <Finances totalToGain={this.state.totalToGain} totalGained={this.state.totalGained} totalApp={this.state.totalApp}/>}
                                    <div class="w-100p pX-20">
                                        <div class="w-100p peers jc-fe pR-20">
                                            <input class="input-muted bdc-client-secondary bgc-grey-200" type="text" placeholder="informe o nome ou cpf do cliente"/>
                                            <button class="open-details btn btn-clear pX-5 pY-0 bdrs-2 mR-5 cur-p  c-client-default" type="button">
                                                <i class="fa fa-filter icon-big"></i>
                                            </button>
                                        </div>

                                        {headers[server.userType]}

                                        {filtered[this.state.filterPage]}
                                    </div>
                                    <div class="pagination p-20">
                                        <div onClick={this.state.filterPage == 0 ? null : () => {this.setState({filterPage: this.state.filterPage - 1})}} class="block">
                                            <i class="fa fa-angle-left"></i>
                                        </div>
                                        <div class="block c-client-secondary">{this.state.filterPage + 1} de {Object.keys(filtered).length}</div>
                                        <div onClick={this.state.filterPage == Object.keys(filtered).length - 1 ? null : () => {this.setState({filterPage: this.state.filterPage + 1})}} class="block">
                                            <i class="fa fa-angle-right"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Filter/>
            </div>
        )
    }
}

export default Management;


// WEBPACK FOOTER //
// ./src/pages/management/Management.js